export default {"src":"/_next/static/media/Jason.dd66a020.svg","height":350,"width":350,"blurWidth":0,"blurHeight":0};